import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/orders/returns')({
  staticData: {
    title: 'route.orders.returns',
    crumb: 'route.orders.returns',
    permissions: ['orders_returns_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
